import posthog from "posthog-js";

export function trackEvent(event, properties = {}) {
  try {
    posthog.capture(event, properties);
  } catch {
    // analytics must never break the app
  }
}
